var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-avatar',_vm._g(_vm._b({staticClass:"avatar-float",attrs:{"size":"100px"}},'v-avatar',attrs,false),on),[_c('img',{attrs:{"alt":"Avatar","src":require("@/assets/IMG_0122.png")}})])]}}])},[_c('span',[_vm._v("Change Basemap Style")])])}
var staticRenderFns = []

export { render, staticRenderFns }